/**
 * @generated SignedSource<<1f1b4a8a87064bfa8b6c3de7d602dd2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ReturnsFormattedPrice_financialAmount$data = {
  readonly convertedAmountList: ReadonlyArray<{
    readonly amount: number | null;
    readonly currency: Currency | null;
  } | null> | null;
  readonly " $fragmentType": "ReturnsFormattedPrice_financialAmount";
};
export type ReturnsFormattedPrice_financialAmount$key = {
  readonly " $data"?: ReturnsFormattedPrice_financialAmount$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReturnsFormattedPrice_financialAmount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReturnsFormattedPrice_financialAmount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "convertedAmountList",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FinancialAmount",
  "abstractKey": null
};

(node as any).hash = "d0b3af6ac3d546a2c3e4c9f2cb953e47";

export default node;
